import { useGlobalStore } from "@obsbot/remo-stores";
import { eventBus } from "@obsbot/remo-utils";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ChatMsg, ChatSendInput, ChatType, IMsgItem } from "remo-components";
const ChannelMsg: React.FC = () => {
    const params = useParams();
    const { userInfo } = useGlobalStore();
    const [referenceMsg, setReferenceMessage] = useState<IMsgItem | null>(null);
    const [conversationID, setConversationID] = useState<string>("");

    useEffect(() => {
        if (params.roomUUID) {
            const tempConversationID = "GROUP" + params.roomUUID;
            setConversationID(tempConversationID);
        }
    }, [params.roomUUID]);

    const handleSendMessage = (): void => {
        eventBus.emit("send-new-msg", {
            userID: userInfo?.user_id || "",
            conversationID,
        });
    };

    return (
        <div className="interactive-msg">
            {conversationID && (
                <ChatMsg
                    chatType={ChatType.Channel}
                    conversationID={conversationID}
                    count={2}
                    hoverWindow={true}
                    referenceMessage={referenceMsg}
                    setReferenceMessage={setReferenceMessage}
                />
            )}
            <ChatSendInput
                chatType={ChatType.Channel}
                handleSendMessage={handleSendMessage}
                hoverWindow={true}
                referenceMessage={referenceMsg}
                setReferenceMessage={setReferenceMessage}
            />
        </div>
    );
};

export default ChannelMsg;
